import vueApp from '@/store';

const st = () => vueApp.state.fexeria_store;

// Rol y empresa salen de GET /api/fexeria/access/ (una vez al entrar al módulo).
export const ensureAccess = async () => {
  if (!st().access.loaded) await vueApp.dispatch('fexeria_store/loadAccess');
  return true;
};

const requireSuper = () => (st().access.role === 'admin_sipmovil' ? true : { name: 'fexeria-home' });

const requireConfigurer = () => (st().access.canConfigure ? true : { name: 'fexeria-home' });

// Un admin SipMóvil sin empresa elegida va al listado.
const requireCompany = () => {
  if (st().access.denied || st().access.company) return true;
  vueApp.dispatch('fexeria_store/toast', 'Elige primero una empresa para ver esta sección.');
  return { name: 'fexeria-empresas' };
};

export default {
  name: 'fexeria',
  component: () =>
    import(/* webpackChunkName: "fexeria-layout" */ '@/modules/fexeria/layouts/FexeriaLayout.vue'),
  redirect: '/fexeria/inicio',
  children: [
    {
      path: 'empresas',
      name: 'fexeria-empresas',
      meta: { crumb: 'Listado de empresas' },
      beforeEnter: requireSuper,
      component: () =>
        import(/* webpackChunkName: "fexeria-empresas" */ '@/modules/fexeria/pages/FexeriaCompanies.vue'),
    },
    {
      path: 'inicio',
      name: 'fexeria-home',
      meta: { crumb: 'Inicio' },
      beforeEnter: requireCompany,
      component: () =>
        import(/* webpackChunkName: "fexeria-home" */ '@/modules/fexeria/pages/FexeriaHome.vue'),
    },
    {
      path: 'entregables-comerciales',
      name: 'fexeria-comerciales',
      meta: { crumb: 'Entregables Comerciales' },
      beforeEnter: requireCompany,
      component: () =>
        import(
          /* webpackChunkName: "fexeria-deliverables" */ '@/modules/fexeria/pages/FexeriaDeliverables.vue'
        ),
      props: { module: 'com' },
    },
    {
      path: 'entregables-fexeria',
      name: 'fexeria-entregables',
      meta: { crumb: 'Entregables Fexería' },
      beforeEnter: requireCompany,
      component: () =>
        import(
          /* webpackChunkName: "fexeria-deliverables" */ '@/modules/fexeria/pages/FexeriaDeliverables.vue'
        ),
      props: { module: 'fex' },
    },
    {
      path: 'configuracion',
      name: 'fexeria-config',
      meta: { crumb: 'Configuración' },
      beforeEnter: [requireConfigurer, requireCompany],
      component: () =>
        import(/* webpackChunkName: "fexeria-config" */ '@/modules/fexeria/pages/FexeriaConfig.vue'),
      props: (route) => ({ tab: route.query.tab || 'fexeria' }),
    },
    {
      path: 'viaje',
      name: 'fexeria-viaje',
      meta: { crumb: 'Viaje Interactivo', fullscreen: true },
      beforeEnter: requireCompany,
      component: () =>
        import(/* webpackChunkName: "fexeria-viaje" */ '@/modules/fexeria/pages/FexeriaViaje.vue'),
    },
  ],
};
